import { render } from "./BoardCrumbs.vue?vue&type=template&id=5b7e170c&scoped=true"
import script from "./BoardCrumbs.vue?vue&type=script&lang=js"
export * from "./BoardCrumbs.vue?vue&type=script&lang=js"

import "./BoardCrumbs.vue?vue&type=style&index=0&id=5b7e170c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7e170c"]])

export default __exports__